import React, { useEffect } from 'react';

const TerritoryInfoWifi = ({ cantonTerritory, selectedCity, selectedCanton, selectedRegion, selectedArea, wifiPointLocationData }) => {


  // считаем по группам
  const wifiCounts = wifiPointLocationData?.reduce(
    (acc, item) => {
      if (item.wifiTypeId === 1) acc.type1++;
      if (item.wifiTypeId === 2) acc.type2++;
      if (item.wifiTypeId === 3) acc.type3++;
      return acc;
    },
    { type1: 0, type2: 0, type3: 0 }
  );

  if (cantonTerritory) {
    return (
      <div className="divCurrentLink" style={{ padding: "10px", fontSize: "14px", marginTop:'0px' }}>
        <label style={{ color: "#d1d1d1", textShadow: "2px 2px 4px rgba(8, 8, 8, 1)" }}>Выбранная территория</label>
        <hr style={{ margin: "2px", color: "#ffe08aff" }} />
        {cantonTerritory && (
          <>
            <label style={{ color: 'white', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Округ: <span style={{ color: '#fcc205',textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{selectedCanton}</span></label>
           
            {selectedRegion && selectedRegion !== "null" &&(
              <>
                <br/>
                <span style={{ color: 'white', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Регион: </span>
                <span style={{ color: '#fcc205', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{selectedRegion}</span>
              </>
            )}
           
            {selectedArea && selectedArea !== "null" && (
              <>
                <br/>
                <span style={{ color: 'white', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>Ветка: </span>
                <span style={{ color: '#fcc205', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{selectedArea}</span>
              </>
            )}
             {/* выводим количество по типам */}
            <br/><br/>
            <div style={{ color: 'white', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>
              <div style={{ color: "#d1d1d1", textShadow: "2px 2px 4px rgba(8, 8, 8, 1)" }}>Wi-Fi</div>
                <hr style={{ margin: "2px", color: "#ffe08aff" }} />
               {wifiCounts?.type1 > 0 && (
                  <div>BaseStation: <span style={{ color: '#fcc205' }}>{wifiCounts.type1} шт.</span></div>
                )}

                {wifiCounts?.type2 > 0 && (
                  <div>Station: <span style={{ color: '#fcc205' }}>{wifiCounts.type2} шт.</span></div>
                )}

                {wifiCounts?.type3 > 0 && (
                  <div>AccessPoint: <span style={{ color: '#fcc205' }}>{wifiCounts.type3} шт.</span></div>
                )}
            </div>
          </>
        )}
      </div>
    );
  } else {
    return null;
  }
}

export default TerritoryInfoWifi;